export default __webpack_public_path__ + "static/media/awaiting4F.900bbc78.svg";